<template>
  <div class="enlace-container">
		<div class="bg-pic">
			<img src="/fotos/last-image.jpg" width="100%" />
		</div>

		<div class="row justify-content-center m-0 list-credits">
			<div class="col-md-7 col-12 col-lg-4">
				<div class="credits">

					<h2 class="text-center creditos-title">
						{{ $t('creditos.title_creditos') }}
					</h2>

					<div class="mt-3 mb-5">
						<div>
							<div class="text-center">
								<span class="title">{{ $t('creditos.direccion') }}:</span>
								<div class="mb-3 nombre">
									{{ $t('creditos.lista_direccion') }}
								</div>

								<span class="title">{{ $t('creditos.fotografia') }}:</span>
								<div class="mb-3 nombre">
									{{ $t('creditos.lista_fotografia') }}
								</div>

								<span class="title">{{ $t('creditos.text') }}:</span>
								<div class="mb-3 nombre">{{ $t('creditos.lista_text') }}</div>

								<span class="title">{{ $t('creditos.edicion') }}:</span>
								<div class="mb-3 nombre">
									{{ $t('creditos.lista_edicion') }}
								</div>

								<span class="title">{{ $t('creditos.traduccion') }}:</span>
								<div class="mb-3 nombre">
									{{ $t('creditos.lista_traduccion') }}
								</div>

								<span class="title">{{ $t('creditos.desarrollo') }}:</span>
								<div class="mb-3 nombre">
									{{ $t('creditos.lista_desarrollo') }}
								</div>

								<span class="title">{{ $t('creditos.director_digital') }}:</span>
								<div class="mb-3 nombre">
									{{ $t('creditos.lista_director') }}
								</div>

								<span class="title">{{ $t('creditos.directora_estrategia') }}:</span>
								<div class="mb-3 nombre">
									{{ $t('creditos.lista_directora') }}
								</div>								

								<span class="title">{{ $t('creditos.director_general') }}:</span>
								<div class="mb-3 nombre">
									{{ $t('creditos.lista_general') }}
								</div>

								

												
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>


export default {
  name: 'Enlaces'
}
</script>